export const historicalGroups = [
    // Example: ['node1_current', 'node2_older', 'node3_oldest']
    // You should replace these with actual Pano2VR node ID arrays
    ['node10', 'node1'], 
    ['node79', 'node4'], 
];